import { Params } from '@angular/router';
import {CovanceGridColumn} from '../covance-ag-grid/covance-grid-column';
export type DateRangeType = 'dateRange' | 'today' | 'monthToDate' | 'yearToDate';
import { getAgeInDays } from '../on-screen-results/on-screen-results';
import { isNil } from 'lodash';

export interface FilterFieldDef {
    title?: string;

    type?: FilterFieldType;

    queryParam?: string;

    onChange?: (fieldVal: FilterFieldValue) => void;

    order?: number;

    isServerSideFilter?: boolean;

    isOff?: boolean;

    isPinned?: boolean;

    leaveOnlySelectedItems?: boolean;

    isMatch?: (str: any, entity: any) => boolean;

    getItems?: (entities?: any[]) => any[]; // for select, multiSelect...

    compare?: (a: any, b: any) => number;

    width?: number;

    skipMissingItems?: boolean;
}

export interface FilterFieldValue {
    def: FilterFieldDef;
    queryParamValue?: string;
    value?: any;
    items?: any; // for select, multiSelect...
    filteredFieldName?: string; // for chain
}

export enum FilterFieldType {
    Text,
    Number,
    NumberRange,
    Date,
    DateRange,
    Select,
    MultiSelect,
    Checkbox,
    ChainNode,
    External,
    AgeRange,
    Age,
    DateTimeRange
}

export interface FilterGridColDef extends CovanceGridColumn {
    filterFieldDef?: FilterFieldDef;
}

export interface FilterQueryParams {
    observableQueryParams: Params;
    allQueryParams: Params;
}

export interface FilterDateRangeValue {
    rangeType: DateRangeType;
    dateBegin: string;
    dateEnd: string;
}

export interface FilterNumberRangeValue {
    min: number;
    max: number;
}

export class FilterAgeRangeValue {
    constructor(public ageValueStart: number, public ageUnitStart: string, public ageValueEnd: number, public ageUnitEnd: string) { }

    public isInRange(daysLived: number) {
        return (!isNil(this.fromDays) ? daysLived >= this.fromDays : true) && (!isNil(this.toDays) ? daysLived <= this.toDays : true);
    }

    public get isValid() {
        return (!this.fromDays || !this.toDays) || this.toDays >= this.fromDays;
    }

    public get fromDays() {
        return getAgeInDays(this.ageValueStart, this.ageUnitStart);
    }

    public get toDays() {
        return getAgeInDays(this.ageValueEnd, this.ageUnitEnd);
    }
}

export class AgeFilter {
    constructor(public operator: string, public day: string) {
    }
}
